// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__GV9dq","modal":"Modal_modal__VuONO","slide-down":"Modal_slide-down__Qs+uD"};